import React, {FC, useState} from 'react';
import cn from 'classnames';
import {useLocalizer} from '@/common/services/localizer';
import {useInformerConfigState} from '@/informers/services/informerConfigReducer';
import {FormLocation} from '../FormLocation';
import {FormSize} from '../FormSize';
import {FormContent} from '../FormContent';
import {FormView} from '../FormView';
import {FormComplete} from '../FormComplete';
import styles from './Form.css';

const steps = ['location', 'size', 'content', 'view', 'complete'] as const;

export const Form: FC = () => {
	const t = useLocalizer();
	const [currentStep, setCurrentStep] = useState<typeof steps[number]>(steps[0]);
	const {state} = useInformerConfigState();

	const handleStageSet = (event: React.MouseEvent<HTMLElement>) => {
		const index = Number(event.currentTarget.dataset.index);
		setCurrentStep(steps[index]);
	};

	const handleNextStageSwitch = () => {
		const currentIndex = steps.indexOf(currentStep);
		setCurrentStep(steps[currentIndex + 1]);
	};
	const handleReset = () => {
		setCurrentStep(steps[0]);
	};

	return (
		<div className={styles.root}>
			{steps.map((stepItem, index) => (
				<div key={stepItem} className={styles.stepContainer}>
					<div
						className={cn(
							styles.stepHeader,
							stepItem === currentStep && styles.isExpanded,
							state.locations.length === 0 && styles.isDisabled,
						)}
						data-index={index}
						data-human-index={index + 1}
						onClick={state.locations.length === 0 ? undefined : handleStageSet}>
						{t(`steps.${stepItem}`)}
					</div>
					{stepItem === currentStep && (
						<div className={styles.stepContent}>
							{stepItem === 'location' && <FormLocation onNextStage={handleNextStageSwitch} />}
							{stepItem === 'size' && <FormSize onNextStage={handleNextStageSwitch} />}
							{stepItem === 'content' && <FormContent onNextStage={handleNextStageSwitch} />}
							{stepItem === 'view' && <FormView onNextStage={handleNextStageSwitch} />}
							{stepItem === 'complete' && <FormComplete onReset={handleReset} />}
						</div>
					)}
				</div>
			))}
		</div>
	);
};

Form.displayName = 'Form';
